import cn from 'classnames'
import BaseModal, {
  BaseModalProps,
} from 'ext-ui/components/BaseModal/BaseModal'
import React, { ReactElement } from 'react'
import ReviewEnrollCard, {
  ReviewEnrollCardProps,
} from 'src/app/ReviewEnrollCard/ReviewEnrollCard'

import style from './ConnectPhysicalCardModal.style'

type ConnectPhysicalCardModalProps = BaseModalProps & {
  reviewEnrollCardProps: ReviewEnrollCardProps
}

export default function ConnectPhysicalCardModal(
  props: ConnectPhysicalCardModalProps,
): ReactElement {
  const {
    className = '',
    variant = 'popup',
    isOpen,
    onClose,
    reviewEnrollCardProps,
  } = props

  return (
    <BaseModal
      className={cn('ConnectPhysicalCardModal', className)}
      variant={variant}
      isOpen={isOpen}
      onClose={onClose}
      css={style}
    >
      <ReviewEnrollCard {...reviewEnrollCardProps} />
    </BaseModal>
  )
}
